import React from 'react'
import Editor from '../Editor/Editor'
import { connect } from 'react-redux'
import './compare-snippets.scss'
import Title from 'antd/es/typography/Title'
import { LANGUAGES } from '../../../constants/languages'
import ExcelAnswerTablesGroup from '../excel-answer-table/ExcelAnswerTablesGroup'

const CompareFiles = ({ snippets }) => {
    const { firstSnippet, secondSnippet } = snippets

    const buildFileContainer = file => {
        let fileContent
        if (file.language === LANGUAGES.EXCEL.value) {
            fileContent = <ExcelAnswerTablesGroup answers={file.content} />
        } else {
            fileContent = (
                <Editor
                    value={file.content}
                    title={
                        <Title level={3} style={{ margin: '8px 0', fontSize: '1rem' }}>
                            {file.name}
                        </Title>
                    }
                    language={file.language}
                    patternsList={file.patternsList}
                />
            )
        }

        return <div className='compare-snippets__snippet-container'>{fileContent}</div>
    }

    const firstFileContent = buildFileContainer(firstSnippet)
    const secondFileContent = buildFileContainer(secondSnippet)

    return (
        <div className='compare-snippets__container'>
            {firstFileContent}
            {secondFileContent}
        </div>
    )
}

const mapState = ({ compareSnippets }) => {
    return {
        snippets: compareSnippets.snippets,
    }
}

export default connect(mapState, null)(CompareFiles)
